import React, { useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import LazyImage from '../../../../Utility/Components/LazyImageComponent';
import Utility from '../../../../Utility/Utility';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
// Component definition - will be memoized at export
const HotelListItems = (props) => {
  const getBranchImage = (branchData) => {
    const fallback = require('../../../../../public/blankImagehotel.jpg');
    if (!branchData) return fallback;

    try {
      const allImages = Array.isArray(branchData.branch_all_images) ? branchData.branch_all_images : [];
      const propertyPhotos = allImages.filter(img =>
        img.asset_category === "PROPERTY" && img.asset_type === "PHOTO"
      );

      const extractFirstUrl = (source) => {
        if (!source) return null;
        let imageUrl = source.image_url !== undefined ? source.image_url : source;

        if (typeof imageUrl === 'string') {
          try {
            imageUrl = JSON.parse(imageUrl);
          } catch (e) {
            // Plain string url or unparseable
          }
        }

        if (Array.isArray(imageUrl) && imageUrl.length > 0) {
          const firstImg = imageUrl[0];
          if (typeof firstImg === 'string') return firstImg;
          return firstImg?.file_url || firstImg?.img_url || firstImg?.image_url || null;
        }

        if (typeof imageUrl === 'object' && imageUrl !== null) {
          return imageUrl.file_url || imageUrl.img_url || imageUrl.image_url || null;
        }

        if (typeof imageUrl === 'string' && imageUrl.trim() !== '') {
          return imageUrl;
        }

        return null;
      };

      for (const img of propertyPhotos) {
        const url = extractFirstUrl(img);
        if (url) return url;
      }

      if (branchData.branch_images) {
        const url = extractFirstUrl(branchData.branch_images);
        if (url) return url;
      }
    } catch (error) {
      console.error("Error parsing branch image:", error);
    }

    return fallback;
  };

  const hotelRoomTypeDetails = useCallback((branchData) => {
    branchData['adults'] = props.adult;
    branchData['child'] = props.child;
    branchData['start_date'] = moment(props.start_date).format('YYYY-MM-DD');
    branchData['end_date'] = moment(props.end_date).format('YYYY-MM-DD');

    const { userSearchDataFromReducer } = props;
    let tempReducer = { ...userSearchDataFromReducer };
    tempReducer['selectedRoom'] = {};
    tempReducer['adult'] = props.adult;
    tempReducer['children'] = props.child;
    tempReducer['start_date'] = props.start_date;
    tempReducer['end_date'] = props.end_date;
    props.userSearchData(tempReducer);
    props.selectChooseBranch(branchData);
    const queryParams = Utility.buildUrlParams(tempReducer);
    props.history.push(`/${localStorage.getItem('i18nextLng')}/property-details/${branchData.slug}?${queryParams}`);
  }, [props.adult, props.child, props.start_date, props.end_date, props.userSearchDataFromReducer, props.userSearchData, props.selectChooseBranch, props.history]);

  if (props.searchResult.length > 0) {
    return props.searchResult.map((branchData, index) => (
      <div className='hotelListBox' key={index}>
        <div className='hotelListBoxLeft'>
          <LazyImage
            src={getBranchImage(branchData)}
            alt={require('../../../../../public/blankImagehotel.jpg')}
            loaderImage={require('../../../../../public/blankImagehotel.jpg')}
            className={"carouselImgpic"}
          />
        </div>
        <div className='hotelListBoxRight'>
          <div className='hotelDetailsBoxes'>
            <div className='hotelDetailsBoxLT'>
              <h5>
                {branchData.hasOwnProperty('star_category') &&
                  branchData.star_category &&
                  Number(branchData.star_category) > 0 ?
                  <OverlayTrigger overlay={<Tooltip>{branchData.star_category} Star Property</Tooltip>}>
                    <span>{branchData.branch_name}  </span>
                  </OverlayTrigger> : <span>{branchData.branch_name}</span>}

                {branchData.hasOwnProperty('star_category') &&
                  branchData.star_category &&
                  Number(branchData.star_category) > 0 &&
                  [...Array(Math.round(Number(branchData.star_category)))].map((_, index) => (
                    <span className='ratingStar' key={index}>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                  ))}
                {/* If there's no rating or the avg is 0, display no stars */}
                {!(branchData.hasOwnProperty('star_category') &&
                  branchData.star_category &&
                  Number(branchData.star_category) > 0) && (
                    <span></span>
                  )}

              </h5>
              <ul className='destinationName'>
                {branchData.branch_full_details.hasOwnProperty('address1') && branchData.branch_full_details.address1 &&
                  <li>
                    <OverlayTrigger overlay={<Tooltip>Address</Tooltip>}>
                      <span ><i className="fa fa-map-marker" aria-hidden="true"></i>
                        {branchData.branch_full_details.address1}
                        {branchData.branch_full_details.hasOwnProperty('address2') && branchData.branch_full_details.address2 != "" &&
                          <>, {branchData.branch_full_details.address2}</>
                        }
                        {branchData.branch_full_details.hasOwnProperty('city') && branchData.branch_full_details.city != "" &&
                          <>, {branchData.branch_full_details.city}</>
                        }
                        {branchData.branch_full_details.hasOwnProperty('state') && branchData.branch_full_details.state != "" &&
                          <>, {branchData.branch_full_details.state}</>
                        }
                        {branchData.branch_full_details.hasOwnProperty('zip') && branchData.branch_full_details.zip != "" &&
                          <>, {branchData.branch_full_details.zip}</>
                        }
                      </span>
                    </OverlayTrigger>
                  </li>
                }
                {branchData.branch_full_details.hasOwnProperty('property_type') && branchData.branch_full_details.property_type &&
                  <li>
                    <OverlayTrigger overlay={<Tooltip>Property type</Tooltip>}>
                      <span >
                        <i className="fa fa-home" aria-hidden="true"></i>
                        {branchData.branch_full_details.property_type}
                      </span>
                    </OverlayTrigger>
                  </li>
                }
              </ul>
              {branchData.branch_wise_amenity.length > 0 &&
                <div className='hotelListBoxRightInnBox'>
                  <p><strong>Property Amenities</strong></p>
                  <ul>
                    {branchData.branch_wise_amenity.map((value, i) => (
                      <li key={i}>
                        <span>
                          <LazyImage
                            src={value?.logo_url && value?.logo_url != "" ? JSON.parse(value?.logo_url).img_url : require('../../../../Utility/Public/images/no-icon1.png')}
                            alt={require('../../../../Utility/Public/images/no-icon1.png')}
                            loaderImage={require('../../../../Utility/Public/images/no-icon1.png')}
                            className={"facilityIcon"}
                          />
                          {value.amenity_name}
                        </span>
                      </li>))}
                  </ul>
                </div>}
              {/* <div className='hotelListBoxRightInnBoxBottom'>
                {branchData.cancellationRule.length == 0 ?
                  <p className='freeCancellation'>✔ Free cancellation.</p>
                  :
                  <p onClick={() => props.viewCancellationDetails(branchData.cancellationRule)} className='cancellationRules'><b>↠</b>Cancellation rules applicable.</p>
                }
                {branchData.branch_wise_booking_rule && Number(branchData.branch_wise_booking_rule.booking_advance_percent) <= 0 ?
                  <p><strong className='grnColor'>✔ No prepayment needed</strong> – pay at the property.</p> :
                  <p><strong><b>↠</b>A minimum payment of {branchData.branch_wise_booking_rule?.booking_advance_percent}% will be required.</strong></p>
                }
                {branchData.branch_wise_total_available_rooms && Number(branchData.branch_wise_total_available_rooms) < 6 && <em>Hurry! Only {branchData.branch_wise_total_available_rooms} room left at this price on our site</em>}
              </div> */}
            </div>
            <div className='hotelDetailsBoxRT'>
              {/* <div className="media reviewBox">
                <div className="media-body">
                  <h4 className="media-heading">Review score</h4>
                  {branchData.hasOwnProperty('customer_rating') &&
                    branchData.customer_rating &&
                    branchData.customer_rating.hasOwnProperty('ratings') && branchData.customer_rating.ratings && (branchData.customer_rating.ratings).length > 0 ?
                    <p><a onClick={(e) => { props.showReviewModalFn(branchData.customer_rating.ratings) }}> {(branchData.customer_rating.ratings).length} Review(s)</a></p> :
                    <p><a > No review</a></p>
                  }
                </div>
                {branchData.hasOwnProperty('customer_rating') &&
                  branchData.customer_rating &&
                  branchData.customer_rating.hasOwnProperty('avg') && branchData.customer_rating.avg != null &&
                  <div className="media-right">
                    {Number(branchData.customer_rating.avg) != 0 ? parseFloat(Math.round(branchData.customer_rating.avg * 10) / 10).toFixed(1) : "0"}
                  </div>}
              </div> */}
              <h5>{Utility.getCurrencySymbol(branchData.currency)} {branchData.total_room_rate}/Night
              </h5>
            </div>
          </div>
          <button className='availabilityBtn' onClick={() => { hotelRoomTypeDetails(branchData) }}>See rooms <i className="fa fa-angle-right" aria-hidden="true"></i></button>
        </div>
        {/* {branchData.food_availability.is_breakfast_available &&
          <div className="vc"><span>Food available</span></div>} */}
      </div>
    ));
  } else {
    if (props.apiCallFinish) {
      return <div className='norecordfound'>No Data Found</div>
    }
  }
};

// Create a pure component with custom comparison to prevent unnecessary re-renders
// Only re-render when critical props change
export default withRouter(React.memo(HotelListItems, (prevProps, nextProps) => {
  // Return true if we should NOT re-render (props are equal)
  if (!prevProps.searchResult && !nextProps.searchResult) return true;
  if (!prevProps.searchResult || !nextProps.searchResult) return false;
  if (prevProps.searchResult.length !== nextProps.searchResult.length) return false;
  
  // Compare essential props for equality
  const startDateEqual = prevProps.start_date?.toString() === nextProps.start_date?.toString();
  const endDateEqual = prevProps.end_date?.toString() === nextProps.end_date?.toString();
  const adultsEqual = prevProps.adult === nextProps.adult;
  const childrenEqual = prevProps.child === nextProps.child;
  
  // Deep comparison of search result arrays
  let searchResultEqual = true;
  if (prevProps.searchResult.length === nextProps.searchResult.length) {
    // Only check IDs to avoid expensive deep comparison
    for (let i = 0; i < prevProps.searchResult.length; i++) {
      if (prevProps.searchResult[i].branch_id !== nextProps.searchResult[i].branch_id) {
        searchResultEqual = false;
        break;
      }
    }
  } else {
    searchResultEqual = false;
  }
  
  return adultsEqual && childrenEqual && startDateEqual && endDateEqual && searchResultEqual;
}));
